import { atom } from 'recoil';

export const registerState = atom<{ isOK: boolean }>({
	key: 'registerState',
	default: { isOK: true },
});
